import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RuleFolderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rule_folder"}/>
}
